import React from "react";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "@/src/types/SummaryDetailsProps";

const SummaryDetailsEvent = ({ caseData }: SummaryDetailsProps) => {
  return (
    <>
      <SummaryDetailsItem fieldPath={"reasonForDispute"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"eventType"} caseData={caseData} />

      {caseData.eventType === "public" && (
        <>
          <SummaryDetailsItem fieldPath={"contractNumber"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"numberOfTickets"} caseData={caseData} />
        </>
      )}
      <SummaryDetailsItem fieldPath={"eventTitle"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"eventCity"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"eventDate"} caseData={caseData} fieldType={"date"} />
    </>
  );
};

export default SummaryDetailsEvent;
